import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const whatsappNumber = '56951081490';
  const message = encodeURIComponent('Hola, me gustaría obtener más información sobre Tu Condominio Digital');

  const handleClick = () => {
    // Usar wa.me que funciona en todas las plataformas
    // En desktop: abre WhatsApp Desktop si está instalado, sino redirige a WhatsApp Web
    // En móvil: abre la app directamente
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 animate-pulse group"
      aria-label="Contactar por WhatsApp"
      title="Envíanos un mensaje por WhatsApp"
    >
      <MessageCircle size={32} className="group-hover:scale-110 transition-transform" />
    </button>
  );
};

export default WhatsAppButton;